export const PARENT_PROFILE_UPDATE_ACTION = 'PARENT_PROFILE_UPDATE_ACTION';
export const PARENT_PROFILE_UPDATE_SUCCESS_ACTION =
  'PARENT_PROFILE_UPDATE_SUCCESS_ACTION';
export const PARENT_PROFILE_UPDATE_FAILURE_ACTION =
  'PARENT_PROFILE_UPDATE_FAILURE_ACTION';
